enum PolicyDataType {
  Bill = 'Bill',
  Regulation = 'Regulation',
  // TODO: Add hearing data, other data to display
}

export default PolicyDataType;
